import { render, staticRenderFns } from "./isi_berita.vue?vue&type=template&id=6a53b470&"
import script from "./isi_berita.vue?vue&type=script&lang=js&"
export * from "./isi_berita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports